import React from "react";

import * as strings from "../../strings";

import createLegalPage from "./sub-components/LegalPage";
import LegalCopy from "./sub-components/LegalCopy";

const PortalPrivacy = createLegalPage(
	"PortalPrivacy",
	strings.LEGAL_PRIVACY_POLICY_PORTAL_TITLE,
	<LegalCopy id={"portal-privacy"} />,
	{
		portal: true,
	},
);

export default PortalPrivacy;
